import { render } from "./MainTypeOfProducts.vue?vue&type=template&id=25840c62&scoped=true"
import script from "./MainTypeOfProducts.vue?vue&type=script&lang=js"
export * from "./MainTypeOfProducts.vue?vue&type=script&lang=js"

import "./MainTypeOfProducts.vue?vue&type=style&index=0&id=25840c62&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25840c62"]])

export default __exports__